import { Col, Form, Modal, Row } from "react-bootstrap";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import { useRef, useState } from "react";
import { GroupButton } from "../../components/GroupButton";

interface IProps {
    open: boolean;
    list: any[];
    handleSave: (listTypeExport: string[]) => void;
    handleClose: (reload?: boolean) => void
}

const DialogTypeExportTimekeeping = (props: IProps) => {
    const {
        open,
        list = [],
        handleSave = () => { },
        handleClose = () => { }
    } = props;

    const { lang } = useMultiLanguage();
    const listCodeExportRef = useRef<string[]>([]);
    const [listTypeExport, setListTypeExport] = useState(list || []);

    const handleCheck = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const isChecked = e.target.checked;
    
        setListTypeExport(prevList => {
            return prevList.map((type, i) => 
                i === index ? { ...type, isChecked } : type
            );
        });

        if (isChecked) {
            listCodeExportRef.current.push((listTypeExport[index]).code);
        } else {
            listCodeExportRef.current = listCodeExportRef.current.filter(code => code !== listTypeExport[index].code);
        }
    };

    if (!open) return <></>

    return (
        <Modal
            show={open}
            onHide={() => {
                handleClose();
            }}
            backdrop="static"
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {`${lang("GENERAL.DATA.EXPORT")}`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {listTypeExport.map((typeExport, index) => {
                        return (
                            <Col xs={12} md={6} lg={6} key={`typeExport-${index}`} className="mb-5">
                                <Form.Group className="d-flex">
                                    <Form.Check
                                        type="checkbox"
                                        label={
                                            <span>{typeExport.value}</span>
                                        }
                                        value={typeExport.value}
                                        checked={typeExport.isChecked || false}
                                        onChange={(e: any) => handleCheck(e, index)}
                                    />
                                </Form.Group>
                            </Col>
                        );
                    })}
                </Row>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <GroupButton
                    type="btn-save"
                    handleSubmit={() => {
                        handleSave(listCodeExportRef.current);
                    }}
                />
                <GroupButton
                    type="btn-cancel"
                    handleCloseUpdateDialog={() => {
                        handleClose();
                    }}
                />
            </Modal.Footer>
        </Modal>
    )
};

export default DialogTypeExportTimekeeping;